var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10651",
    "data-name": "Group 10651",
    transform: "translate(-4 -48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2352",
    "data-name": "Rectangle 2352",
    width: 20,
    height: 20,
    rx: 2,
    transform: "translate(4 48)",
    fill: "#f6f6f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10652",
    "data-name": "Group 10652",
    transform: "translate(-7.998 40.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25046",
    "data-name": "Path 25046",
    d: "M28.839,10.807H27.371V9.339a.841.841,0,0,0-.839-.839H15.838A.841.841,0,0,0,15,9.339v13.42a.841.841,0,0,0,.839.839h1.468v1.468a.841.841,0,0,0,.839.839H28.839a.841.841,0,0,0,.839-.839V11.645A.841.841,0,0,0,28.839,10.807Zm-13,12.162a.213.213,0,0,1-.21-.21V9.339a.213.213,0,0,1,.21-.21H26.532a.213.213,0,0,1,.21.21v1.468h-8.6a.841.841,0,0,0-.839.839V22.969Zm13.21,2.1a.213.213,0,0,1-.21.21H18.144a.213.213,0,0,1-.21-.21V11.645a.213.213,0,0,1,.21-.21H28.839a.213.213,0,0,1,.21.21Z",
    transform: "translate(0)",
    fill: "#d5ad28",
    stroke: "#d5ad28",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25047",
    "data-name": "Path 25047",
    d: "M39.816,43.629h6.29a.315.315,0,0,0,0-.629h-6.29a.315.315,0,0,0,0,.629Z",
    transform: "translate(-19.364 -27.266)",
    fill: "#d5ad28",
    stroke: "#d5ad28",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25048",
    "data-name": "Path 25048",
    d: "M39.816,33.629h6.29a.315.315,0,1,0,0-.629h-6.29a.315.315,0,0,0,0,.629Z",
    transform: "translate(-19.364 -19.363)",
    fill: "#d5ad28",
    stroke: "#d5ad28",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25049",
    "data-name": "Path 25049",
    d: "M39.816,53.629h6.29a.315.315,0,1,0,0-.629h-6.29a.315.315,0,0,0,0,.629Z",
    transform: "translate(-19.364 -35.169)",
    fill: "#d5ad28",
    stroke: "#d5ad28",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25050",
    "data-name": "Path 25050",
    d: "M60.814,64a.315.315,0,0,0-.315.315v2.516a.315.315,0,1,0,.629,0V64.315A.315.315,0,0,0,60.814,64Z",
    transform: "translate(-35.959 -43.862)",
    fill: "#d5ad28",
    stroke: "#d5ad28",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25051",
    "data-name": "Path 25051",
    d: "M70.814,67a.315.315,0,0,0-.315.315V69.2a.315.315,0,0,0,.629,0V67.315A.315.315,0,0,0,70.814,67Z",
    transform: "translate(-43.862 -46.233)",
    fill: "#d5ad28",
    stroke: "#d5ad28",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25052",
    "data-name": "Path 25052",
    d: "M65.814,70a.315.315,0,0,0-.315.315v1.258a.315.315,0,1,0,.629,0V70.315A.315.315,0,0,0,65.814,70Z",
    transform: "translate(-39.911 -48.604)",
    fill: "#d5ad28",
    stroke: "#d5ad28",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25053",
    "data-name": "Path 25053",
    d: "M39.386,62a1.887,1.887,0,1,0,1.887,1.887A1.887,1.887,0,0,0,39.386,62Zm-1.258,1.887a1.258,1.258,0,0,1,2.516-.01l-1.182-.3a.315.315,0,0,0-.381.381l.3,1.181a1.257,1.257,0,0,1-1.248-1.258Zm1.858,1.106-.168-.674.674.168a1.264,1.264,0,0,1-.505.505Z",
    transform: "translate(-17.782 -42.282)",
    fill: "#d5ad28",
    stroke: "#d5ad28",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.b2335b1eb73e2ca26eadcd909d6ec307.svg";
export { ForwardRef as ReactComponent };